import { CreateOrEditSubscriptionPage } from "./CreateOrEditSubscriptionPage";
interface EditSubscriptionPageProps {
    subscriptionId: string;
}
export function SubscriptionPage({ subscriptionId }: EditSubscriptionPageProps) {
    return <CreateOrEditSubscriptionPage subscriptionId={subscriptionId}/>;
}
